export const classnames = (...args) => {
  return args.join(" ");
};
